import { setTransactionSignatures } from "@/state/transactions/CurrentTransactionEvents";
import { Signatory, Signature } from "@/type/core/dashboard/dashboard.types";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";
import { Col, Row, Select } from "antd";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface ChooseModelSignatureModalProps extends BasicModalProps {
  signatories: Signatory[];
  signaturesFromModel: Signature[];
  firstFileFromModelName?: string;
}

const ChooseModelSignatureModal: FunctionComponent<
  ChooseModelSignatureModalProps
> = ({
  signatories,
  signaturesFromModel,
  firstFileFromModelName,
  ...props
}) => {
  const { t } = useTranslation();

  const onChange = (email: string, value: string) => {
    const newSignaturesFromModel = signaturesFromModel.map((signature) => {
      if (signature.email === email && String(signature.name) !== value) {
        return {
          ...signature,
          email: undefined,
        };
      }
      if (String(signature.name) === value) {
        return {
          ...signature,
          email,
        };
      }
      return signature;
    });
    setTransactionSignatures(newSignaturesFromModel);
  };

  return (
    <BasicModal
      title={t("offices.transactionModel.modal.signatureTitle")}
      buttonText={t("offices.transactionModel.modal.yes")}
      {...props}
    >
      {firstFileFromModelName ? (
        <Col sm="12">
          <Row>
            <Col className="mb-16" sm="12">
              <strong>{firstFileFromModelName}</strong>
            </Col>
          </Row>
          {signatories.map((signatory, signatoryIndex) => {
            const signature = signaturesFromModel.find(
              (signature) => signature.email === signatory.email,
            );
            const signatureName = signature ? signature.name : "";
            return (
              <Row
                className="mb-4 d-flex justify-content-between"
                key={signatoryIndex}
              >
                <Col sm="6" className={"d-flex align-items-center"}>
                  {signatory.email}
                </Col>
                <Col sm="6">
                  <Select
                    className="w-250px"
                    value={signatureName}
                    onChange={(value) => {
                      onChange(signatory.email, value);
                    }}
                  >
                    <Select.Option value="">
                      {t("offices.transactionModel.modal.chooseSignature")}
                    </Select.Option>
                    {signaturesFromModel
                      .filter(
                        (signature) =>
                          signature.email === undefined ||
                          signature.email === null ||
                          signature.email === signatory.email,
                      )
                      .map((signature, signatureIndex) => (
                        <Select.Option
                          key={signatureIndex}
                          value={signature.name}
                        >
                          {signature.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Col>
              </Row>
            );
          })}
        </Col>
      ) : (
        ""
      )}
    </BasicModal>
  );
};

export default ChooseModelSignatureModal;
